import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "~/components/Tooltip";

// // // //

export function SelectLoginGate(props: {
    isLoggedIn: boolean;
    tooltipText?: string;
    children: React.ReactNode;
}) {
    const {
        isLoggedIn,
        children,
        tooltipText = "Log in to unlock controls",
    } = props;

    if (isLoggedIn) {
        return <>{children}</>;
    }

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <div className="flex items-center gap-1.5 px-3 py-2 text-sm">
                    <FontAwesomeIcon icon={faLock} className="h-2.5 w-2.5" />
                    <p className="text-sm">{tooltipText}</p>
                </div>
            }
        >
            {({ setTriggerRef }) => <div ref={setTriggerRef}>{children}</div>}
        </Tooltip>
    );
}
